const serverPath = "https://api.buffet.top2top.net";

export default serverPath;
